import React from 'react';
import styled from 'styled-components';

function StepLabelBadge({ children, className }) {
  return (
    <StepLabelContainer className={className}>
      {children}
    </StepLabelContainer>
  );
}

const StepLabelContainer = styled.span`
  display: inline-flex;
  align-items: center;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #A154EA;
  padding: 8px 20px;
  background: #ffffff;
  border-radius: 32px;
  border: 1px solid #DEC7FF;
  white-space: nowrap;
`;

export default StepLabelBadge;
